import { render, staticRenderFns } from "./BodReport.vue?vue&type=template&id=3e0f9230&scoped=true&"
import script from "./BodReport.vue?vue&type=script&lang=js&"
export * from "./BodReport.vue?vue&type=script&lang=js&"
import style0 from "./BodReport.vue?vue&type=style&index=0&id=3e0f9230&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0f9230",
  null
  
)

export default component.exports